import { render, staticRenderFns } from "./UserSettingsApiAccess.vue?vue&type=template&id=161bf1e4&"
import script from "./UserSettingsApiAccess.vue?vue&type=script&lang=js&"
export * from "./UserSettingsApiAccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports